<template>
  <div :id="$style.dream_post_menu">
    <div id="dream_post_top" :class="$style.top"></div>
    <dream-post-list :items="items_data"></dream-post-list>
    <b-pagination
      v-model="currentPage"
      :total-rows="count"
      :per-page="perPage"
      @input="handleClick(currentPage)"
      v-scroll-to="'#dream_post_top'"
    ></b-pagination>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import DreamPostList from "@/components/organsms/dream_post/DreamPostList.vue";
import { DreamPost } from "@/api";

export default Vue.extend({
  name: "DreamPostMenu",
  components: {
    DreamPostList,
  },
  data() {
    return {
      count: 0,
      items_data: [],
      currentPage: 1,
      perPage: 1,
    };
  },
  mounted() {
    this.handleClick("1");
  },
  methods: {
    handleClick(pagenum) {
      DreamPost.getDreamItem(pagenum).then(({ count, results }) => {
        this.count = Math.ceil(count / 2);
        this.items_data = results;
      });
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #dream_post_menu {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    .top {
      position: absolute;
      top: 350px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #dream_post_menu {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    .top {
      position: absolute;
      top: 300px;
    }
  }
}
</style>
